import { render, staticRenderFns } from "./CertificationPageCreate.vue?vue&type=template&id=0e65564e&"
import script from "./CertificationPageCreate.vue?vue&type=script&lang=ts&"
export * from "./CertificationPageCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e65564e')) {
      api.createRecord('0e65564e', component.options)
    } else {
      api.reload('0e65564e', component.options)
    }
    module.hot.accept("./CertificationPageCreate.vue?vue&type=template&id=0e65564e&", function () {
      api.rerender('0e65564e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Certifications/CertificationPageCreate.vue"
export default component.exports